var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3875 0.315186H2.72078C1.57495 0.315186 0.637451 1.25269 0.637451 2.39852V19.0652C0.637451 20.211 1.57495 21.1485 2.72078 21.1485H19.3875C20.5333 21.1485 21.4708 20.211 21.4708 19.0652V2.39852C21.4708 1.25269 20.5333 0.315186 19.3875 0.315186ZM6.88745 19.0652H2.72078V14.8985H6.88745V19.0652ZM6.88745 12.8152H2.72078V8.64852H6.88745V12.8152ZM6.88745 6.56519H2.72078V2.39852H6.88745V6.56519ZM13.1375 19.0652H8.97079V14.8985H13.1375V19.0652ZM13.1375 12.8152H8.97079V8.64852H13.1375V12.8152ZM13.1375 6.56519H8.97079V2.39852H13.1375V6.56519ZM19.3875 19.0652H15.2208V14.8985H19.3875V19.0652ZM19.3875 12.8152H15.2208V8.64852H19.3875V12.8152ZM19.3875 6.56519H15.2208V2.39852H19.3875V6.56519Z",
    fill: "#78A22F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridActive);
export default __webpack_public_path__ + "static/media/grid-active.5714a216e6c1fd4bd8c6f91146fa05dc.svg";
export { ForwardRef as ReactComponent };